import { Component, Input } from '@angular/core';
import { RoleMatrix } from '../../../../helpers';

@Component({
    selector: 'app-breadcrumb-work-order-edit',
    templateUrl: './breadcrumb.work.order.edit.component.html'
})

export class BreadcrumbWorkOrderEditComponent {

    roleMatrix: RoleMatrix;

    @Input() companyId: number;
    @Input() viewType: number;

    constructor() {
        this.roleMatrix = new RoleMatrix();
    }
}
